<div
  style="
    margin-bottom: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
    box-shadow: 0 7px 7px 0 rgb(210 210 210 / 50%);
  "
  class="ng-star-inserted"
>
  <i style="font-size: 96px" class="anticon anticon-icomoon:aaa-logo-color">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="currentColor"
      width="1em"
      height="1em"
      data-icon="icomoon:aaa-logo-color"
      aria-hidden="true"
    >
      <path
        fill="#00529b"
        d="M31.846 7.019c-0.929-1.608-5.866-0.588-12.008 2.239 0.323 0.249 0.62 0.511 0.886 0.786 4.714-1.987 8.367-2.609 9.11-1.322 0.878 1.52-2.574 5.22-8.066 8.916l0.062 0.066c6.729-4.379 11.056-8.885 10.016-10.686z"
      ></path>
      <path
        fill="#00529b"
        d="M2.776 24.344c-0.542-0.939 0.571-2.711 2.793-4.799v0c-0.178-0.064-0.353-0.13-0.524-0.199-0.010-0.004-0.020-0.008-0.029-0.012-0.174-0.071-0.347-0.145-0.514-0.222v0c-2.673 2.461-4.028 4.558-3.395 5.654 0.742 1.284 4.041 0.893 8.47-0.758l-0.050-0.072c-3.541 1.233-6.138 1.471-6.751 0.408z"
      ></path>
      <path
        fill="#ed1c2e"
        d="M0 13.577c0-3.808 4.991-6.895 11.149-6.895s11.149 3.087 11.149 6.895-4.992 6.895-11.149 6.895c-6.158 0-11.149-3.087-11.149-6.895zM6.32 8.212l2.094 7.183h0.011l2.234-8.108c-1.586 0.057-3.065 0.388-4.339 0.926zM10.542 11.187l-1.151 4.208h2.325l-1.173-4.208zM13.843 15.395l1.993-7.241c-1.288-0.521-2.778-0.834-4.371-0.871l2.37 8.112h0.008zM6.279 15.395l-1.153-4.208-1.151 4.208h2.304zM19.499 16.241c0.553-0.81 0.864-1.712 0.864-2.664 0-1.843-1.158-3.5-3.003-4.652l2.138 7.316zM17.132 15.395l-1.174-4.208-1.144 4.208h2.318zM17.367 16.238h-2.782l-0.242 0.891 0.636 2.177c1.080-0.338 2.048-0.814 2.855-1.396l-0.467-1.672zM7.349 19.299l-0.839-3.061h-2.766l-0.235 0.86c0.949 0.96 2.277 1.731 3.836 2.215l0.004-0.015zM11.951 16.238h-2.791l-0.908 3.319c0.911 0.206 1.885 0.32 2.897 0.32 0.61 0 1.206-0.042 1.783-0.119l-0.981-3.519zM4.759 9.041c-1.74 1.146-2.824 2.754-2.824 4.536 0 0.943 0.305 1.836 0.847 2.638l1.977-7.174z"
      ></path>
    </svg>
  </i>
</div>
